import { UntypedFormGroup } from '@angular/forms';
import { DSM3SelectOption } from '@eredes/dsm3';
import { Subject } from 'rxjs';

export class ReopenRequestViewModel {
  constructor(
    public formGroup: UntypedFormGroup,
    public $reasons: Subject<DSM3SelectOption[]>
  ) {}
}
